module.exports = __webpack_public_path__ + "img/HT01078-113.5e30b696.jpg";